import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

const data = [
  { year: 2017, A: 22, B: 18 },
  { year: 2018, A: 14, B: 9 },
  { year: 2019, A: 27, B: 22 },
  { year: 2020, A: 31, B: 26 },
  { year: 2021, A: 40, B: 34 },
  { year: 2022, A: 43, B: 38 },
  { year: 2023, A: 45, B: 40 },
];

export default function YearlySalesChart() {
  return (
    <div
      style={{
        background: "#fff",
        padding: "25px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
        height: 370
      }}
    >
      <h3 style={{ marginBottom: 20, color: "#333" }}>Yearly Stock Report</h3>

      <ResponsiveContainer width="100%" height="80%">
        <LineChart data={data}>
          <XAxis dataKey="year" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="A" stroke="#2ec9d3" strokeWidth={3} />
          <Line type="monotone" dataKey="B" stroke="#0b2b4c" strokeWidth={3} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
